export const button = {
  textAlign: 'right',
}

export const inputReason = {
  width: '100%',
}

export const innerFormGroup = {
  marginLeft: 0,
}
